import { QueryClient } from "@tanstack/react-query";

export const reactQuery = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10, // seconds
    },
  },
});
